import React, { Component } from 'react'

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

import green from '@material-ui/core/colors/green'
import teal from '@material-ui/core/colors/teal'

import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import Avatar from '@material-ui/core/Avatar'
import Menu, { MenuItem } from '@material-ui/core/Menu'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import { Async } from 'react-select'
import 'react-select/dist/react-select.css'

import ContainerDisplayLists from '../containers/ContainerDisplayLists'

import ContainerCustomDrawer from '../containers/ContainerCustomDrawer'
import ContainerLoginDialog from '../containers/ContainerLoginDialog'
import ContainerProfile from '../containers/ContainerProfile'

import ScrollToTop from './ScrollToTop'

import { fetchPosts } from '../actions/index'
import { translate } from 'react-i18next'

// import * as firebase from 'firebase'
const firebase = require('firebase')

const theme = createMuiTheme({
  palette: {
    primary: {
      main: teal[500]
    },
    secondary: {
      main: green[500]
    }
  }
});

const styles = {
  root: {
    flexGrow: 1,
    backgroundColor: '#f5f5f5',
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: 5,
    marginRight: 20,
  },
  responsiveSetting: {
    maxWidth: '740px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

class ComponentAppBar extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { dispatch, switchAuthStatus, toggleLoginDialog, setUser, i18n } = this.props
    dispatch(fetchPosts())

    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
          // User is signed in.
          dispatch(switchAuthStatus(true))
          dispatch(toggleLoginDialog(false))
          dispatch(setUser(user))

          //// test //////
          let customUser = {
            providerId: user.providerId,
            displayName: user.displayName,
            email: user.email,
            photoURL: user.photoURL,
            fblike: 0,
            fbcomment: 0,
            show: true
          }

          firebase.firestore().collection('users').doc(user.uid).get().then(doc => {
            if (doc.exists) {
              console.log("Document data:", doc.data())
            } else {
              // create a user if user's data doesn't exist
              firebase.firestore().collection('users').doc(user.uid).set(customUser)
            }
          }).catch(error => console.log("Error getting document:", error))
          ///////////////////

          //// test //////
          user.providerData.forEach(function (profile) {
            console.log("Sign-in provider: " + profile.providerId);
            console.log("  Provider-specific UID: " + profile.uid);
            console.log("  Name: " + profile.displayName);
            console.log("  Email: " + profile.email);
            console.log("  Photo URL: " + profile.photoURL);
          });
          ////////////////
        } else {
          // No user is signed in. Or user just signed out.
          dispatch(switchAuthStatus(false))
          dispatch(setUser(null))
        }
    })
  }

  render() {
    const { auth, anchorEl, switchAuthStatus, handleMenu, handleClose, classes, selectedCategory, handleCategoryChange, selectedLocation, handleLocationChange, onClickSearch, toggleNavDrawer, user, t, tReady} = this.props
    const open = Boolean(anchorEl)

    const firestore = firebase.firestore()

    let historyInput = null

    const getCategoryOptions = (input, callback) => {
      // get dropdown list for categories
      firestore.collection('categories').orderBy('total', 'desc').get().then(function(querySnapshot) {
        let options = querySnapshot.docs.map(doc => {
          return { value: doc.data().alias, label: `${t('alias:' + doc.data().alias)} (${doc.data().total})` }
        })

          callback(null, {
            options: options,
            // CAREFUL! Only set this to true when there are no more options,
            // or more specific queries will not be sent to the server.
            complete: true
          })
      })
      .catch(function(error) {
          console.log("Error getting documents: ", error)
      })
    }

    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <Router>
            <div>
              <AppBar position="sticky">
                <Toolbar>
                  <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={() => toggleNavDrawer()}>
                    {/* <MenuIcon /> */}
                    <Icon style={{overflow: 'visible', marginRight: '3px'}}><i className="fab fa-forumbee" style={{verticalAlign: 'bottom'}}></i></Icon>
                    <KeyboardArrowDown  style={{color: 'lightgrey'}} />
                  </IconButton>
                  <Route render={({ history}) => (
                    <Async name="category" className={classes.flex} value={selectedCategory} onChange={e => handleCategoryChange(e, history)} placeholder={t('search_placeholder')}
                      loadOptions={getCategoryOptions}
                      cache={false}
                    />
                  )} />
                  {auth && (
                    <div>
                      <IconButton
                        aria-owns={open ? 'menu-appbar' : null}
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                      >
                        {/* <AccountCircle /> */}
                        {user && <Avatar alt="Remy Sharp" src={user.photoURL} />}
                      </IconButton>
                      <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={open}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleClose}>Profile</MenuItem>
                        <MenuItem onClick={handleClose}>My account</MenuItem>
                      </Menu>
                    </div>
                  )}
                </Toolbar>
              </AppBar>
              <ScrollToTop>
                <div className={classes.responsiveSetting}>
                  <ContainerCustomDrawer />
                  <ContainerLoginDialog />
                  <Switch>
                    <Route exact path='/' component={ContainerDisplayLists}/>
                    <Route path="/profile/:profileUrl" component={ContainerProfile}/>
                    {/* when none of the above match, <NoMatch> will be rendered */}
                    <Route render={() => (
                      <h3>404 not found</h3>
                    )}/>
                  </Switch>
                </div>
              </ScrollToTop>
            </div>
          </Router>
        </div>
      </MuiThemeProvider>
    )
  }
}

ComponentAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default translate(['translations', 'alias'])(withStyles(styles)(ComponentAppBar));


// WEBPACK FOOTER //
// ./src/components/ComponentAppBar.js